export default "__VITE_ASSET__16lUh3eC__"